import { render, staticRenderFns } from "./PolicyList.vue?vue&type=template&id=2989edc4&scoped=true&"
import script from "./PolicyList.vue?vue&type=script&lang=js&"
export * from "./PolicyList.vue?vue&type=script&lang=js&"
import style0 from "./PolicyList.vue?vue&type=style&index=0&id=2989edc4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2989edc4",
  null
  
)

export default component.exports